import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const products = [
    {
      id: 1,
      name: 'Plise Perde',
      image: 'https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/7f8afe63362e43a7fe7c9829cdee9621.jpeg',
      color: 'bg-pink-50',
      link: '/urunler/plise-perde'
    },
    {
      id: 2,
      name: 'Jaluzi Perde',
      image: 'https://public.readdy.ai/ai/img_res/430694b968672fa4437b96ace0dd30d1.jpg',
      color: 'bg-emerald-50',
      link: '/urunler/jaluzi-perde'
    },
    {
      id: 3,
      name: 'Tül & Fon Perde',
      image: 'https://readdy.ai/api/search-image?query=luxurious%20sheer%20tulle%20curtains%20flowing%20elegantly%20in%20a%20bright%20modern%20living%20room%20with%20soft%20diffused%20natural%20light%20creating%20ethereal%20atmosphere%20against%20clean%20white%20walls%20and%20minimalist%20furniture&width=400&height=500&seq=tul1&orientation=portrait',
      color: 'bg-gray-50',
      link: '/urunler/tul-perde'
    },
    {
      id: 4,
      name: 'Zebra Perde',
      image: 'https://readdy.ai/api/search-image?query=modern%20zebra%20roller%20blinds%20with%20alternating%20fabric%20stripes%20in%20a%20contemporary%20bedroom%20featuring%20clean%20minimalist%20design%20with%20soft%20natural%20lighting%20and%20neutral%20color%20palette%20against%20white%20walls&width=400&height=500&seq=zebra1&orientation=portrait',
      color: 'bg-amber-50',
      link: '/urunler/zebra-perde'
    },
    {
      id: 5,
      name: 'Stor Perde',
      image: 'https://readdy.ai/api/search-image?query=elegant%20roller%20blinds%20in%20a%20modern%20minimalist%20interior%20with%20clean%20white%20walls%20and%20soft%20natural%20lighting%20showcasing%20smooth%20fabric%20texture%20in%20warm%20neutral%20tones%20with%20contemporary%20design%20aesthetic&width=400&height=500&seq=stor1&orientation=portrait',
      color: 'bg-blue-50',
      link: '/urunler/stor-perde'
    },
    {
      id: 6,
      name: 'Fon Perde',
      image: 'https://readdy.ai/api/search-image?query=luxurious%20blackout%20curtains%20in%20rich%20fabric%20draped%20elegantly%20in%20a%20sophisticated%20bedroom%20with%20soft%20ambient%20lighting%20and%20minimalist%20design%20featuring%20deep%20neutral%20tones%20against%20clean%20white%20walls&width=400&height=500&seq=fon1&orientation=portrait',
      color: 'bg-slate-50',
      link: '/urunler/fon-perde'
    },
    {
      id: 7,
      name: 'Halı',
      image: 'https://readdy.ai/api/search-image?query=premium%20quality%20carpet%20with%20intricate%20patterns%20in%20a%20modern%20living%20room%20featuring%20elegant%20design%20and%20rich%20textures%20in%20warm%20neutral%20tones%20against%20clean%20minimalist%20interior%20with%20soft%20natural%20lighting&width=400&height=500&seq=hali1&orientation=portrait',
      color: 'bg-rose-50',
      link: '/urunler/hali'
    },
    {
      id: 8,
      name: 'Yatak & Baza',
      image: 'https://readdy.ai/api/search-image?query=luxurious%20upholstered%20bed%20with%20elegant%20headboard%20and%20base%20in%20a%20modern%20minimalist%20bedroom%20featuring%20premium%20fabric%20in%20neutral%20tones%20with%20soft%20lighting%20and%20clean%20white%20walls%20showcasing%20comfort%20and%20style&width=400&height=500&seq=yatak1&orientation=portrait',
      color: 'bg-indigo-50',
      link: '/urunler/yatak-baza'
    }
  ];

  const features = [
    {
      icon: 'ri-ruler-line',
      title: 'Ücretsiz Ölçüm',
      description: 'Uzman ekibimiz evinize gelerek profesyonel ölçüm hizmeti sunar.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Profesyonel Montaj',
      description: 'Deneyimli montaj ekibimizle kusursuz kurulum garantisi veriyoruz.'
    },
    {
      icon: 'ri-shield-check-line',
      title: '2 Yıl Garanti',
      description: 'Tüm ürünlerimizde 2 yıl kapsamlı garanti ve servis desteği.'
    }
  ];

  const testimonials = [
    {
      name: 'Ayşe Yılmaz',
      text: 'Üçoklar Perde ile çalışmak harikaydı. Ürün kalitesi ve montaj hizmeti mükemmeldi. Evimiz çok daha şık görünüyor.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20turkish%20woman%20smiling%20warmly%20portrait%20photo%20with%20clean%20white%20background%20natural%20lighting%20friendly%20expression&width=80&height=80&seq=avatar1&orientation=squarish'
    },
    {
      name: 'Mehmet Kaya',
      text: 'Plise perdelerimizi buradan aldık. Hem fiyat hem kalite açısından çok memnun kaldık. Herkese tavsiye ederim.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20turkish%20man%20smiling%20confidently%20portrait%20photo%20with%20clean%20white%20background%20natural%20lighting%20friendly%20expression&width=80&height=80&seq=avatar2&orientation=squarish'
    },
    {
      name: 'Zeynep Demir',
      text: 'Halı ve perde alışverişimizi yaptık. Ürünler çok kaliteli ve montaj ekibi son derece profesyoneldi.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20turkish%20woman%20with%20glasses%20smiling%20portrait%20photo%20with%20clean%20white%20background%20natural%20lighting%20friendly%20expression&width=80&height=80&seq=avatar3&orientation=squarish'
    },
    {
      name: 'Ali Özkan',
      text: 'Yatak ve baza setimizi aldık. Uyku kaliteniz artıyor gerçekten. Teşekkürler Üçoklar Perde.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20turkish%20man%20with%20beard%20smiling%20portrait%20photo%20with%20clean%20white%20background%20natural%20lighting%20friendly%20expression&width=80&height=80&seq=avatar4&orientation=squarish'
    },
    {
      name: 'Fatma Arslan',
      text: 'Duvar kağıdı ve ev tekstili ürünlerini çok beğendik. Evimize çok yakıştı, çok teşekkürler.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20turkish%20woman%20with%20hijab%20smiling%20warmly%20portrait%20photo%20with%20clean%20white%20background%20natural%20lighting%20friendly%20expression&width=80&height=80&seq=avatar5&orientation=squarish'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-16 w-auto" />
            </Link>
            
            <div className="hidden lg:flex items-center space-x-10">
              <Link to="/" className={`text-base font-semibold transition-all duration-300 whitespace-nowrap hover:scale-105 ${isScrolled ? 'text-gray-900 hover:text-amber-600' : 'text-white hover:text-amber-200'}`} style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '0.5px' }}>Ana Sayfa</Link>
              <Link to="/urunler" className={`text-base font-semibold transition-all duration-300 whitespace-nowrap hover:scale-105 ${isScrolled ? 'text-gray-900 hover:text-amber-600' : 'text-white hover:text-amber-200'}`} style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '0.5px' }}>Ürünler</Link>
              <Link to="/hali" className={`text-base font-semibold transition-all duration-300 whitespace-nowrap hover:scale-105 ${isScrolled ? 'text-gray-900 hover:text-amber-600' : 'text-white hover:text-amber-200'}`} style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '0.5px' }}>Halı Satışı</Link>
              <Link to="/ev-tekstili" className={`text-base font-semibold transition-all duration-300 whitespace-nowrap hover:scale-105 ${isScrolled ? 'text-gray-900 hover:text-amber-600' : 'text-white hover:text-amber-200'}`} style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '0.5px' }}>Ev Tekstili</Link>
              <Link to="/hakkimizda" className={`text-base font-semibold transition-all duration-300 whitespace-nowrap hover:scale-105 ${isScrolled ? 'text-gray-900 hover:text-amber-600' : 'text-white hover:text-amber-200'}`} style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '0.5px' }}>Hakkımızda</Link>
              <Link to="/iletisim" className={`text-base font-semibold transition-all duration-300 whitespace-nowrap hover:scale-105 ${isScrolled ? 'text-gray-900 hover:text-amber-600' : 'text-white hover:text-amber-200'}`} style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '0.5px' }}>İletişim</Link>
            </div>

            <div className="hidden lg:flex items-center gap-4">
              <Link to="/iletisim" className="bg-amber-700 hover:bg-amber-800 text-white px-8 py-3 rounded-full text-base font-semibold transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Teklif Al
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white shadow-lg">
            <div className="px-4 py-6 space-y-4">
              <Link to="/" onClick={() => setMobileMenuOpen(false)} className="block text-base font-semibold text-gray-900 hover:text-amber-600 transition-colors py-2" style={{ fontFamily: "'Poppins', sans-serif" }}>Ana Sayfa</Link>
              <Link to="/urunler" onClick={() => setMobileMenuOpen(false)} className="block text-base font-semibold text-gray-900 hover:text-amber-600 transition-colors py-2" style={{ fontFamily: "'Poppins', sans-serif" }}>Ürünler</Link>
              <Link to="/hali" onClick={() => setMobileMenuOpen(false)} className="block text-base font-semibold text-gray-900 hover:text-amber-600 transition-colors py-2" style={{ fontFamily: "'Poppins', sans-serif" }}>Halı Satışı</Link>
              <Link to="/ev-tekstili" onClick={() => setMobileMenuOpen(false)} className="block text-base font-semibold text-gray-900 hover:text-amber-600 transition-colors py-2" style={{ fontFamily: "'Poppins', sans-serif" }}>Ev Tekstili</Link>
              <Link to="/hakkimizda" onClick={() => setMobileMenuOpen(false)} className="block text-base font-semibold text-gray-900 hover:text-amber-600 transition-colors py-2" style={{ fontFamily: "'Poppins', sans-serif" }}>Hakkımızda</Link>
              <Link to="/iletisim" onClick={() => setMobileMenuOpen(false)} className="block text-base font-semibold text-gray-900 hover:text-amber-600 transition-colors py-2" style={{ fontFamily: "'Poppins', sans-serif" }}>İletişim</Link>
              <Link to="/iletisim" onClick={() => setMobileMenuOpen(false)} className="block bg-amber-700 hover:bg-amber-800 text-white px-6 py-3 rounded-full text-base font-semibold text-center transition-colors whitespace-nowrap cursor-pointer mt-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Teklif Al
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src="https://readdy.ai/api/search-image?query=brilliant%20sheer%20curtain%20fabric%20close%20up%20photo%20showing%20delicate%20translucent%20texture%20with%20soft%20natural%20light%20filtering%20through%20elegant%20flowing%20drapes%20in%20neutral%20beige%20cream%20tones%20professional%20product%20photography%20clean%20background&width=1920&height=1080&seq=brillanthero1&orientation=landscape" 
            alt="Hero Background" 
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-4">
            Evinize Zarafet
          </h1>
          <p className="text-4xl md:text-5xl lg:text-6xl font-serif italic text-white mb-4">
            Katan Perdeler
          </p>
          <p className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-12">
            ve Ev Tekstili
          </p>
          <Link to="/urunler" className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
            Ürünleri Keşfet →
          </Link>
        </div>

        <div className="absolute bottom-0 left-0 right-0 flex items-end justify-center gap-8 px-4 pb-12">
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-72 transform hover:scale-105 transition-transform cursor-pointer">
            <div className="w-full h-48 mb-4">
              <img src="https://readdy.ai/api/search-image?query=elegant%20modern%20curtains%20in%20soft%20beige%20tones%20hanging%20beautifully%20in%20minimalist%20interior%20with%20clean%20white%20background%20showcasing%20premium%20fabric%20quality%20and%20sophisticated%20design&width=280&height=192&seq=card1&orientation=landscape" alt="Perdeler" className="w-full h-full object-cover object-top rounded-lg" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Premium Perdeler</h3>
            <p className="text-sm text-gray-600 mt-2">Geniş ürün yelpazesi</p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl p-6 w-80 transform scale-110 hover:scale-115 transition-transform cursor-pointer -mb-8">
            <div className="w-full h-56 mb-4">
              <img src="https://readdy.ai/api/search-image?query=luxurious%20premium%20carpet%20with%20elegant%20patterns%20in%20warm%20neutral%20tones%20displayed%20in%20modern%20minimalist%20showroom%20with%20clean%20white%20background%20highlighting%20intricate%20design%20and%20quality%20craftsmanship&width=320&height=224&seq=card2&orientation=landscape" alt="Halı" className="w-full h-full object-cover object-top rounded-lg" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900">Kaliteli Halılar</h3>
            <p className="text-sm text-gray-600 mt-2">Evinize sıcaklık katın</p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl p-6 w-72 transform hover:scale-105 transition-transform cursor-pointer">
            <div className="w-full h-48 mb-4">
              <img src="https://readdy.ai/api/search-image?query=modern%20elegant%20bed%20with%20upholstered%20headboard%20in%20neutral%20beige%20tones%20premium%20quality%20furniture%20in%20minimalist%20bedroom%20with%20clean%20white%20background%20showcasing%20comfort%20and%20sophisticated%20design&width=280&height=192&seq=card3&orientation=landscape" alt="Yatak" className="w-full h-full object-cover object-top rounded-lg" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Konforlu Yataklar</h3>
            <p className="text-sm text-gray-600 mt-2">Kaliteli uyku için</p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <p className="text-sm text-gray-500 mb-2">Neden Üçoklar Perde?</p>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-2">Kaliteli Ürünler</h2>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900">Profesyonel Montaj</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-3xl text-amber-700`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <p className="text-sm font-serif text-gray-500 mb-2">Ürün Kategorilerimiz</p>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900">Geniş Ürün</h2>
            <h2 className="text-5xl md:text-6xl font-serif italic text-gray-900">Yelpazesi</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
            {products.map((product) => (
              <Link 
                key={product.id} 
                to={product.link}
                className="group cursor-pointer"
              >
                <div className={`${product.color} rounded-3xl overflow-hidden h-96 transition-transform hover:scale-105`}>
                  <div className="w-full h-80">
                    <img 
                      src={product.image} 
                      alt={product.name} 
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-4 text-center">
                    <h3 className="text-lg font-semibold text-gray-900">{product.name}</h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
              <i className="ri-star-fill text-teal-600"></i>
              <span className="text-sm font-medium text-teal-900">Müşteri Yorumları</span>
            </div>
            <h2 className="text-5xl font-bold text-gray-900">Müşterilerimiz Ne Diyor?</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12">
                    <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover object-top rounded-full" />
                  </div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                </div>
                <div className="mb-4">
                  <i className="ri-double-quotes-l text-4xl text-gray-300"></i>
                </div>
                <p className="text-gray-600 leading-relaxed">{testimonial.text}</p>
                <div className="flex gap-1 mt-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-center">
            <div className="lg:col-span-1">
              <div className="inline-block border-2 border-gray-300 rounded-full px-4 py-2 mb-6">
                <span className="text-sm font-medium text-gray-700">Hakkımızda</span>
              </div>
              <div className="w-full h-96 rounded-3xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20curtain%20showroom%20interior%20with%20elegant%20display%20of%20various%20curtain%20types%20and%20home%20textile%20products%20modern%20lighting%20warm%20atmosphere%20customers%20browsing%20quality%20fabrics%20in%20sophisticated%20retail%20space&width=400&height=600&seq=about1&orientation=portrait" 
                  alt="Showroom" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:col-span-2">
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">30 Yıllık</h2>
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">Tecrübe ile</h2>
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8">Hizmetinizdeyiz</h2>
              <p className="text-lg text-gray-600 mb-4 leading-relaxed">
                Üçoklar Perde olarak 30 yıldır Ankara'da perde, halı, yatak ve ev tekstili sektöründe hizmet vermekteyiz. Müşteri memnuniyetini ön planda tutarak, kaliteli ürünler ve profesyonel hizmet anlayışıyla sektörde öncü konumdayız.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Plise perde, jaluzi perde, tül perde, fon perde, stor perde ve zebra perde imalatı ile birlikte halı satışı, yatak-baza-başlık, duvar kağıdı ve ev tekstili ürünlerinde geniş bir yelpaze sunuyoruz.
              </p>
              <Link to="/hakkimizda" className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-3 rounded-full text-base font-medium transition-colors whitespace-nowrap cursor-pointer">
                Daha Fazla Bilgi
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative h-screen">
        <div className="grid grid-cols-1 lg:grid-cols-2 h-full">
          <div className="relative bg-amber-50 flex items-center justify-center p-12">
            <div className="absolute inset-0">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20measuring%20service%20expert%20measuring%20window%20for%20curtain%20installation%20in%20modern%20home%20interior%20with%20measuring%20tape%20and%20tools%20clean%20minimalist%20background%20showcasing%20professional%20service%20quality&width=800&height=1000&seq=cta1&orientation=portrait" 
                alt="Ücretsiz Keşif" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
            </div>
            <div className="relative z-10 text-left w-full max-w-md">
              <div className="inline-block bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                <span className="text-sm font-medium text-gray-900">Ücretsiz Keşif</span>
              </div>
              <h3 className="text-5xl md:text-6xl font-bold text-white mb-2 drop-shadow-lg">Ücretsiz</h3>
              <h3 className="text-5xl md:text-6xl font-bold text-white mb-2 drop-shadow-lg">Keşif ve</h3>
              <h3 className="text-5xl md:text-6xl font-bold text-white drop-shadow-lg">Ölçüm</h3>
            </div>
          </div>

          <div className="bg-white flex items-center justify-center p-12">
            <div className="text-center max-w-md">
              <h3 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">Hemen İletişime</h3>
              <h3 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8">Geçin</h3>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Uzman ekibimiz size en uygun çözümleri sunmak için hazır. Ücretsiz keşif ve ölçüm hizmeti için hemen iletişime geçin.
              </p>
              <a 
                href="https://wa.me/905336178275" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                WhatsApp ile İletişim →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <path d="M0,200 Q300,100 600,200 T1200,200" stroke="currentColor" strokeWidth="1" fill="none"/>
            <path d="M0,220 Q300,120 600,220 T1200,220" stroke="currentColor" strokeWidth="1" fill="none"/>
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
            <div className="lg:col-span-2">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-36 mb-6" />
              <p className="text-teal-100 mb-6 leading-relaxed">
                30 yıllık tecrübemizle evinize zarafet katıyoruz. Kaliteli ürünler ve profesyonel hizmet anlayışıyla yanınızdayız.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ürünler</h4>
              <ul className="space-y-3">
                <li><Link to="/urunler/plise-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Plise Perde</Link></li>
                <li><Link to="/urunler/jaluzi-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Jaluzi Perde</Link></li>
                <li><Link to="/urunler/tul-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Tül Perde</Link></li>
                <li><Link to="/urunler/fon-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Fon Perde</Link></li>
                <li><Link to="/urunler/zebra-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Zebra Perde</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ev Tekstili</h4>
              <ul className="space-y-3">
                <li><Link to="/hali" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Halı Satışı</Link></li>
                <li><Link to="/urunler/yatak-baza" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Yatak & Baza</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Duvar Kağıdı</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Ev Tekstili</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <ul className="space-y-3">
                <li className="text-teal-100 text-sm leading-relaxed">
                  <i className="ri-map-pin-line mr-2"></i>
                  Kemalpaşa, Cumhuriyet Cd. No:52, 06780 Elmadağ/Ankara
                </li>
                <li>
                  <a href="tel:+905336178275" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-phone-line mr-2"></i>
                    0533 617 82 75
                  </a>
                </li>
                <li>
                  <a href="mailto:info@ucoklarperde.com" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-mail-line mr-2"></i>
                    info@ucoklarperde.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-teal-600 pt-8">
            <p className="text-teal-100 text-sm text-center">© 2025 Üçoklar Perde. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/905336178275" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 cursor-pointer group"
      >
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp ile İletişim
        </span>
      </a>
    </div>
  );
}